<template>
	<div class="Login_ui">
		<div class="login_box" :style="bgStyle">
			<div class="title" :style="titleStyle">{{datas.title}}</div>
			<div class="btn" @click="toLogin()">登录</div>
		</div>
	</div>
</template>

<script>
	export default {
		props: ["datas"],
		computed: {
			bgStyle(){
				if(this.datas.bgStyle=='color'){
					return `background: ${this.datas.bgColor};`
				}else if(this.datas.bgStyle=='pic'){
					return `background: url(${this.datas.bgPic}) no-repeat;background-size: cover;`
				}
			},
			titleStyle(){
				var titleStyle =''
				if(this.datas.titleColor){
					titleStyle +=`color:${this.datas.titleColor};`
				}
				
				return titleStyle
			}
		},
		methods: {
			toLogin(){
				var url = encodeURIComponent(window.location.href);
       			window.location.href = '/wechat/?/#/memberLogin?redirect_url=' + url;
			},
		},
		mounted() {
			console.log(this.datas)
		}


	};
</script>
<style lang="less" scoped>
	@import url("~@/styles/mixin.less");

	.Login_ui {
		padding: 0 0.3999rem;
		.login_box{
			border-radius: 10px;
			overflow: hidden;
			display: flex;
			align-items: center;
			justify-content: space-between;
			padding: 0.61318rem 0.3999rem;
			background: #31313B;
			
			.title{
				flex: 1;
				font-size: 14px;
				color: #FFFFFF;
				padding-right: 0.3999rem;
				line-height: 0.533rem;
				max-height: 1.066rem;
				 display: -webkit-box;
				-webkit-box-orient: vertical;
				-webkit-line-clamp: 2;
				overflow: hidden;
				white-space: normal;
				word-break: break-all;
				font-family: PingFangSC-Semibold;
			}
			.btn{
				font-family: PingFangSC-Semibold;
				font-size: 14px;
				color: #31313B;
				padding: 0.18662rem 0.95976rem;
				border-radius: 0.45322rem;
				background: #fff;
			}
			
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/polymerization/Login.vue